var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-receipt"},[_c('detail-receipt-plan',{staticClass:"table-wrap",attrs:{"contract":_vm.contract}}),_c('detail-receipt-record',{staticClass:"table-wrap",attrs:{"contract":_vm.contract}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }